export const BASE_URL = process.env.REACT_APP_API_ENDPOINT

export const OPEN_RESPONSE_MODAL = 'OPEN_RESPONSE_MODAL'
export const SET_KEYWORD_SEARCH = 'SET_KEYWORD_SEARCH'

export const SALE_PRODUCT_LIST_REQUEST = 'SALE_PRODUCT_LIST_REQUEST'
export const SALE_PRODUCT_LIST_SUCCESS = 'SALE_PRODUCT_LIST_SUCCESS'
export const SALE_PRODUCT_LIST_FAILURE = 'SALE_PRODUCT_LIST_FAILURE'

export const SALE_PRODUCT_GET_REQUEST = 'SALE_PRODUCT_GET_REQUEST'
export const SALE_PRODUCT_GET_SUCCESS = 'SALE_PRODUCT_GET_SUCCESS'
export const SALE_PRODUCT_GET_FAILURE = 'SALE_PRODUCT_GET_FAILURE'
export const SALE_PRODUCT_GET_RESET = 'SALE_PRODUCT_GET_RESET'

export const SALE_PRODUCT_CREATE_REQUEST = 'SALE_PRODUCT_CREATE_REQUEST'
export const SALE_PRODUCT_CREATE_SUCCESS = 'SALE_PRODUCT_CREATE_SUCCESS'
export const SALE_PRODUCT_CREATE_FAILURE = 'SALE_PRODUCT_CREATE_FAILURE'
export const SALE_PRODUCT_CREATE_RESET = 'SALE_PRODUCT_CREATE_RESET'

export const SALE_PRODUCT_EDIT_REQUEST = 'SALE_PRODUCT_EDIT_REQUEST'
export const SALE_PRODUCT_EDIT_SUCCESS = 'SALE_PRODUCT_EDIT_SUCCESS'
export const SALE_PRODUCT_EDIT_FAILURE = 'SALE_PRODUCT_EDIT_FAILURE'
export const SALE_PRODUCT_EDIT_RESET = 'SALE_PRODUCT_EDIT_RESET'

export const SALE_PRODUCT_DELETE_REQUEST = 'SALE_PRODUCT_DELETE_REQUEST'
export const SALE_PRODUCT_DELETE_SUCCESS = 'SALE_PRODUCT_DELETE_SUCCESS'
export const SALE_PRODUCT_DELETE_FAILURE = 'SALE_PRODUCT_DELETE_FAILURE'
export const SALE_PRODUCT_DELETE_RESET = 'SALE_PRODUCT_DELETE_RESET'

export const SALE_PRODUCT_EXPORT_REQUEST = 'SALE_PRODUCT_EXPORT_REQUEST'
export const SALE_PRODUCT_EXPORT_SUCCESS = 'SALE_PRODUCT_EXPORT_SUCCESS'
export const SALE_PRODUCT_EXPORT_FAILURE = 'SALE_PRODUCT_EXPORT_FAILURE'
export const SALE_PRODUCT_EXPORT_RESET = 'SALE_PRODUCT_EXPORT_RESET'

export const SHOW_MANUAL_SALE_PRODUCT = 'SHOW_MANUAL_SALE_PRODUCT'
export const CLOSE_MANUAL_SALE_PRODUCT = 'CLOSE_MANUAL_SALE_PRODUCT'



// WEBPACK FOOTER //
// ./src/actions/sale-product/types.js